export default {"src":"/_next/static/media/logo15_horizontal.a6c29ccb.svg","height":239,"width":432,"blurWidth":0,"blurHeight":0};